/* cf-attribution.js — where did this visitor come from? (28 Sep 2026)
 *
 * Pete: "yes fix the click form source tracking". Until today 78% of Click Fencing leads reached the CRM as plain
 * "Website", so cost per lead by channel (SEO & Ads monitor) could not be worked out for Click.
 *
 * What it does, and nothing else:
 *  1. On every page it records the ENTRANCE — the ad click ids (gclid/gbraid/wbraid/fbclid/msclkid), the utm_ tags,
 *     the referring site's host and the landing path — the first time ever (first touch) and every time the visitor
 *     arrives again from outside (last touch). Browsing inside the site, checkout and payment returns are ignored.
 *     Stored in localStorage only. No cookies, no personal data, nothing sent while they browse.
 *  2. When the visitor sends ANY Click form (contact, calculator plan, visualiser, inspection booking, cart question,
 *     quick price), it notices the outgoing request, takes the email / visitor id it carries, and posts those plus the
 *     two touches to the `click-attribution` function. The CRM attaches the source to that lead.
 *
 * It wraps fetch and sendBeacon but never changes, delays or blocks the original request. Every step is in try/catch:
 * if anything here fails, the forms behave exactly as before.
 * The CHANNEL is worked out on the server (click-attribution), so the rules live in one place.
 */
(function () {
  'use strict';
  if (window.__cfAttr) return;
  window.__cfAttr = true;

  var KEY = 'cf_attr_v1';
  var ENDPOINT = 'https://mhzmtafzxeshqqtktbwh.supabase.co/functions/v1/click-attribution';
  var OWN_HOST = /(^|\.)(clickfencing\.com\.au|myshopify\.com|shopify\.com|shop\.app|shopifycdn\.com|paypal\.com|afterpay\.com|zip\.co|stripe\.com)$/i;
  var WATCH = /supabase\.co\/functions\/v1\/(click-(?!attribution)|cart-question|quick-price|form-intake|public-quote)|workers\.dev|\/apps\/cf-|clickfencing-crm/i;
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'];

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode */ } }
  function clip(s, n) { return s == null ? null : String(s).slice(0, n); }

  // 1. Record this entrance, if it is one.
  try {
    var q = new URLSearchParams(location.search);
    var t = { at: new Date().toISOString(), landing: clip(location.pathname, 200) };
    var hasParam = false;
    PARAMS.forEach(function (k) { var v = q.get(k); if (v) { t[k] = clip(v, 200); hasParam = true; } });
    var refHost = '';
    try { refHost = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ''; } catch (e) { /* */ }
    var external = refHost && !OWN_HOST.test(refHost) && refHost !== location.hostname;
    if (external) t.referrer = clip(refHost, 120);
    var store = read();
    if (hasParam || external || !store.first) {
      if (!store.first) store.first = t;
      // "Last" keeps the latest arrival that says where it came from; a later direct visit does not wipe it.
      if (hasParam || external || !store.last) store.last = t;
      write(store);
    }
  } catch (e) { /* never break the page */ }

  // 2. When a form sends, file the source against the email / visitor id it carries.
  var sentRecently = {};
  var EMAIL = /[A-Z0-9._%+'-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;
  function fromText(s) {
    var out = {};
    if (!s) return out;
    try {
      var m = /"(?:email|customer_email|customerEmail|contact_email)"\s*:\s*"([^"]{3,200})"/i.exec(s);
      out.email = m ? m[1] : ((EMAIL.exec(s) || [])[0] || null);
      var v = /"(?:visitorId|visitor_id|vid)"\s*:\s*"([^"]{4,80})"/i.exec(s);
      if (v) out.visitor_id = v[1];
    } catch (e) { /* */ }
    return out;
  }
  function fromBody(body) {
    try {
      if (!body) return Promise.resolve({});
      if (typeof body === 'string') return Promise.resolve(fromText(body));
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return Promise.resolve(fromText(body.toString().replace(/%40/g, '@')));
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var o = {};
        body.forEach(function (val, k) { if (typeof val === 'string' && /email/i.test(k) && EMAIL.test(val)) o.email = val; });
        return Promise.resolve(o);
      }
      if (typeof Blob !== 'undefined' && body instanceof Blob && body.size < 65536 && body.text) return body.text().then(fromText, function () { return {}; });
    } catch (e) { /* */ }
    return Promise.resolve({});
  }
  function visitor() {
    try { return localStorage.getItem('cf_visitor_id') || null; } catch (e) { return null; }
  }
  function report(url, ids) {
    try {
      var store = read();
      if (!store.first) return;
      var email = ids.email ? String(ids.email).trim().toLowerCase() : null;
      var vid = ids.visitor_id || visitor();
      if (!email && !vid) return;
      var key = (email || '') + '|' + (vid || '');
      if (sentRecently[key] && Date.now() - sentRecently[key] < 15000) return;
      sentRecently[key] = Date.now();
      var endpoint = '';
      try { endpoint = new URL(url, location.href).pathname.split('/').pop(); } catch (e) { /* */ }
      var payload = JSON.stringify({ email: email, visitor_id: vid, endpoint: clip(endpoint, 60), page: clip(location.pathname, 200),
        first: store.first, last: store.last || store.first });
      var blob = new Blob([payload], { type: 'text/plain' });
      if (!(navigator.sendBeacon && _beacon(ENDPOINT, blob))) {
        _fetch(ENDPOINT, { method: 'POST', body: payload, keepalive: true, mode: 'cors' }).catch(function () {});
      }
    } catch (e) { /* */ }
  }

  var _fetch = window.fetch ? window.fetch.bind(window) : null;
  var _beacon = navigator.sendBeacon ? navigator.sendBeacon.bind(navigator) : null;

  if (_fetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && WATCH.test(url)) fromBody(init && init.body).then(function (ids) { report(url, ids); });
      } catch (e) { /* */ }
      return _fetch(input, init);
    };
  }
  if (_beacon) {
    navigator.sendBeacon = function (url, data) {
      try { if (WATCH.test(String(url))) fromBody(data).then(function (ids) { report(url, ids); }); } catch (e) { /* */ }
      return _beacon(url, data);
    };
  }
  // Plain HTML form posts (Shopify's own contact form fallback, anything not sent by script).
  document.addEventListener('submit', function (ev) {
    try {
      var f = ev.target;
      if (!f || !f.querySelector) return;
      var em = f.querySelector('input[type=email], input[name*="email" i]');
      if (em && EMAIL.test(em.value || '')) report(f.getAttribute('action') || location.pathname, { email: em.value });
    } catch (e) { /* */ }
  }, true);
})();
